module.exports = __webpack_public_path__ + "static/media/optibolt-5.b5eb077c.jpg";